import styled from 'styled-components';

export const Panel = styled.li``;
export const PanelBody = styled.div`
    display: flex;
    position: relative;
    padding: 10px 0;
    margin: 20px 0;

    &::before {
        content: '';

        position: absolute;
        display: block;
        top: 0;
        bottom: 0;
        left: -15px;
        width: 5px;

        border-radius: 16px;

        background-color: ${props => props.color};
    }
`;
export const IconContainer = styled.div`
    margin-right: 15px;

    > svg {
        color: ${props => props.color};
    }
`;
export const TrackingContent = styled.div`
    color: #fff;
`;

export const PanelText = styled.div`
    display: block;
    margin: 0;
    font-size: 20px;
    text-align: left;

    > .local-historico-rastreio {
        margin-right: 5px;
        font-weight: bold;
        font-style: italic;
        text-transform: uppercase;
        text-align: left;
    }

    > .data-historico-rastreio {
        font-size: 13px;
        font-weight: lighter;
        text-align: left;
    }

    > .destino-historico-rastreio {
        font-size: 14px;
        font-weight: lighter;
        margin: 0;
        text-align: left;
    }
`;

export const IconTruck = styled.svg`
    width: 28px;
    height: 28px;
`;
